import Box from '@mui/material/Box';
import InputBase from '@mui/material/InputBase';
import React from 'react';

import { AddressValue } from './LocationHelpers';

const fieldInputSx = {
  fontSize: '12px',
  border: '1px solid',
  borderColor: 'v4.borderDark',
  borderRadius: 1,
  px: 1,
  py: 0.5,
  width: '100%',
};

export const ManualAddressForm: React.FC<{
  fields: AddressValue;
  updateField: (key: keyof AddressValue, val: string) => void;
}> = ({ fields, updateField }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
    <InputBase
      placeholder="Line 1 *"
      value={fields.line1 ?? ''}
      onChange={(e) => updateField('line1', e.target.value)}
      inputProps={{ 'aria-label': 'Address line 1' }}
      sx={fieldInputSx}
      // eslint-disable-next-line jsx-a11y/no-autofocus -- first field of a popper is an expected focus target
      autoFocus
    />
    <InputBase
      placeholder="Line 2"
      value={fields.line2 ?? ''}
      onChange={(e) => updateField('line2', e.target.value)}
      inputProps={{ 'aria-label': 'Address line 2' }}
      sx={fieldInputSx}
    />
    <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.75 }}>
      <InputBase
        placeholder="Suburb *"
        value={fields.suburb ?? ''}
        onChange={(e) => updateField('suburb', e.target.value)}
        inputProps={{ 'aria-label': 'Suburb' }}
        sx={fieldInputSx}
      />
      <InputBase
        placeholder="City"
        value={fields.city ?? ''}
        onChange={(e) => updateField('city', e.target.value)}
        inputProps={{ 'aria-label': 'City' }}
        sx={fieldInputSx}
      />
    </Box>
    <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.75 }}>
      <InputBase
        placeholder="State *"
        value={fields.stateName ?? ''}
        onChange={(e) => updateField('stateName', e.target.value)}
        inputProps={{ 'aria-label': 'State' }}
        sx={fieldInputSx}
      />
      <InputBase
        placeholder="Postcode *"
        value={fields.postCode ?? ''}
        onChange={(e) => updateField('postCode', e.target.value)}
        inputProps={{ 'aria-label': 'Postcode' }}
        sx={fieldInputSx}
      />
    </Box>
  </Box>
);
